package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Comment
import com.example.readingnotes.domain.repository.CommentRepository
import com.example.readingnotes.util.Result

class LoadCommentsUseCase(
    private val commentRepository: CommentRepository,
) {
    suspend operator fun invoke(postId: Int): Result<List<Comment>> = commentRepository.getComments(postId)
}
